import React from 'react';
import './PriceSensitivityChart.css';

const PriceSensitivityChart = () => {
    const quotes = [
        { text: "I'd ", bold: "happily pay $1000/mo", suffix: " for @cursor_ai." },
        { text: "Never paid a tool that fast." },
        { bold: "100% worth the subscription fee." },
        { text: "It's ", bold: "well worth the 20 dollars", suffix: " and ", bold2: "some more", suffix2: ", honestly." },
        { text: "I used it for 5 minutes and ", bold: "couldn't get my credit card out fast enough." }
    ];

    return (
        <div className="price-sensitivity-chart">
            <div className="chart-section">
                <div className="bars-container">
                    <div className="bar-group">
                        <span className="bar-value">54%</span>
                        <div className="bar bar-cursor" style={{ height: '200px' }}></div>
                        <div className="bar-label">
                            <span className="company-name">Cursor</span>
                        </div>
                    </div>
                    <div className="bar-group">
                        <span className="bar-value">35%</span>
                        <div className="bar bar-copilot" style={{ height: '130px' }}></div>
                        <div className="bar-label">
                            <span className="company-name">GitHub Copilot</span>
                        </div>
                    </div>
                </div>
                <p className="chart-label">% of Users Willing to Accept a Price Increase</p>
            </div>

            <div className="quotes-section">
                {quotes.map((quote, index) => (
                    <div key={index} className="quote-bubble">
                        <p>
                            {quote.text}
                            {quote.bold && <strong>{quote.bold}</strong>}
                            {quote.suffix}
                            {quote.bold2 && <strong>{quote.bold2}</strong>}
                            {quote.suffix2}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PriceSensitivityChart;
